import Base from 'front/components/Base/Base';
import * as _ from 'underscore';

import lozad from 'lozad';

export default class Page extends Base {
    constructor(options = {}) {
        super(options);
        // Page type is using for active menu item searching
        this.type = '';
        this.title = undefined;
        this.apiUrl = '';

        this.observer = lozad('.lazy', {rootMargin: '200px'});

        this.scrollItems = [];

        this.onResize = this.onResize.bind(this);
        this.onScroll = this.onScroll.bind(this);

        let prevWw = window.innerWidth;
        let onResizeThrottled = _.throttle(this.onResize, 16.6666666 * 8, {leading: false});

        $(window)
            .on('resize', function () {
                var curWw = window.innerWidth;
                this.windowHeight = window.innerHeight;

                if (curWw !== prevWw) {
                    onResizeThrottled();
                }

                prevWw = curWw;
            }.bind(this));

        window.addEventListener('scroll', this.onScroll);

        //proceed resize and scroll with throttle
        onResizeThrottled();

        window.onload = () => {
            this.observer.observe();
        };
    }

    setTitle(title) {
        title = title || this.title;
        if (title !== undefined) {
            document.title = 'Bang! Bang!' + (title ? $('<div> — ' + title + '</div>')
                .text() : '');
        }
    };

    $parent() {
        return app.els.$contentBody;
    };

    activate(params) {
        this.setTitle();

        return super.activate(params);
    }

    updateItemsPos() {
        this.scrollItems.forEach(function (item) {
            item.height = item.$el.height();
            item.top = item.$el.offset().top;
        }.bind(this));
    }

    onResize() {
        window.addEventListener('onResize', this.onScroll);
        this.hasItemsPoses = true;

        $('[data-scroll]').each(function (ind, item) {
            this.scrollItems.push({
                el: item,
                $el: $(item),
                offset: ($(item).attr('data-scroll-offset') - 0) * (!app.settings.isPhone ? 2 : -1),
                screenPosition: -1,
                listeners: {
                    'screen-position': [],
                    'screen-bottom': [],
                    'screen-enter': [],
                    'screen-leave': []
                }
            });

            //we will use custom trigger/on/off realization
            //cause jquery version (the one using dom) is too slow
            $(item).data('listeners', this.scrollItems[this.scrollItems.length - 1].listeners);
        }.bind(this));

        this.updateItemsPos();
        this.windowHeight = window.innerHeight;
        this.onScroll();
    }

    onScroll() {
        if (!this.hasItemsPoses) {
            return;
        }

        let scrollTop = window.pageYOffset;
        let self = this;
        let wh = self.windowHeight;

        let triggerEvent = function (item, eventName, options) {
            var listeners = item.listeners[eventName];
            for (var i = 0; i < listeners.length; i++) {
                listeners[i]({}, options);
            }
        };

        self.scrollItems.forEach(function (item) {
            let screenPosition = (scrollTop - (item.top - wh + item.offset)) / (item.height + wh - item.offset);
            let screenPositionConstrained = Math.min(Math.max(screenPosition, 0), 1);
            let screenBottom = scrollTop + wh - (item.top + item.height);

            if (item.screenPositionConstrained !== screenPositionConstrained) {
                triggerEvent(item, 'screen-position', {
                    $el: item.$el,
                    screenPosition: screenPositionConstrained,
                    height: item.height
                });
                item.screenPositionConstrained = screenPositionConstrained;
            }

            triggerEvent(item, 'screen-bottom', {
                $el: item.$el,
                screenBottom: screenBottom,
                height: item.height
            });


            if ((item.screenPosition < 0 && screenPosition >= 0) || (item.screenPosition > 1 && screenPosition <= 1)) {
                if (item['data-scroll-state'] !== 'enter') {
                    triggerEvent(item, 'screen-enter', {
                        $el: item.$el
                    });

                    $(item.$el).removeClass('isHide');

                    item['data-scroll-state'] = 'enter';
                }
            }

            item.screenPosition = screenPosition;
        });
    }
}

